import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, ListItemSecondaryAction } from '@material-ui/core';
import styles from './PeviewElements.style';
import { ReactComponent as PushPinIcon } from 'assets/svgs/push_pin.svg';
import { ReactComponent as PushPinOutlinedIcon } from 'assets/svgs/push_pin_outlined.svg';
import { PIN_MAX_LIMIT, HIDE_PIN_ICON_FIELDS } from 'constants/constant';
import { colors } from 'theme/color-palette';
import { setPinnedAttribute, setPinnedAttributeSnackbar } from '../Preview.actions';

const PinAttributeButton = ({ show, attributeType, businessName, pinId }) => {
	const classes = styles();
	const dispatch = useDispatch();
	const templateId = useSelector((state) => state.templateReducer.selectedTemplate);
	const pinnedAttributeCollection = useSelector((state) => state.previewReducer.pinnedAttribute);

	const currentPinnedAttributes = pinnedAttributeCollection[templateId] || {
		metrics: [],
		dimensions: []
	};
	const pinnedMetrics = currentPinnedAttributes?.metrics || [];
	const pinnedDimensions = currentPinnedAttributes?.dimensions || [];
	const isPinned = [...pinnedMetrics, ...pinnedDimensions].includes(businessName);

	const onButtonClick = (e) => {
		e.stopPropagation();

		let newPinnedAttributes = { ...currentPinnedAttributes };

		// Remove already Pinned item
		if (isPinned) {
			if (attributeType === 'dimensions') {
				newPinnedAttributes.dimensions = pinnedDimensions.filter((item) => item !== businessName);
			}
			if (attributeType === 'measures') {
				newPinnedAttributes.metrics = pinnedMetrics.filter((item) => item !== businessName);
			}
		} else {
			// Add the item to Pinned list
			// Check the total count of attributes, if it reaches max limit, then shows the snackbar
			if (pinnedMetrics.length + pinnedDimensions.length >= PIN_MAX_LIMIT) {
				dispatch(setPinnedAttributeSnackbar(true));
				return;
			}
			if (attributeType === 'dimensions') {
				newPinnedAttributes.dimensions = [...pinnedDimensions, businessName];
			}
			if (attributeType === 'measures') {
				// metrics refers to measures
				newPinnedAttributes.metrics = [...pinnedMetrics, businessName];
			}
		}
		dispatch(
			setPinnedAttribute({
				templateId,
				newPinnedAttributes
			})
		);
	};

	const hidePinFlag = HIDE_PIN_ICON_FIELDS.some(
		(value) => value.toLowerCase() === attributeType.toLowerCase()
	);
	// Pinned Icon should not show for unpinned attributes, Time periods, Custom Attributes
	if ((!show && !isPinned) || hidePinFlag) {
		return null;
	}
	// Pinned Icon element will be hidden unless the attribute is pinned OR the attribute is hovered
	const visibility = show || isPinned ? 'visible' : 'hidden';

	return (
		<ListItemSecondaryAction id={pinId} onClick={onButtonClick}>
			<Box
				title="Pin Attribute"
				style={{ visibility }}
				className={classes.pinnedIcon}
				data-test-id="pin-attribute-button">
				{isPinned ? (
					<PushPinIcon
						fontSize="small"
						style={{ color: colors.SNOMO_PURPLE, width: 18, height: 18 }}
					/>
				) : (
					<PushPinOutlinedIcon style={{ width: 18, height: 18 }} fontSize="small" />
				)}
			</Box>
		</ListItemSecondaryAction>
	);
};

export default PinAttributeButton;
